"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchUserGroups = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const ActionTypes = require("../../actionTypes/bid/userGroups");
const Actions = require("../../actions/bid/userGroups");
const sok_types_1 = require("@caddigital/sok-types");
const errorHandling_1 = require("../../utils/errorHandling");
const translation_1 = require("../../utils/translation");
function fetchUserGroups(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/user-group/folder/${action.payload.uuid}`
    }).pipe((0, operators_1.mergeMap)((xhr) => {
        return t
            .array(sok_types_1.UserGroup.iUserGroup)
            .decode(xhr.response)
            .fold((error) => (0, rxjs_1.of)(Actions.fetchFailed((0, errorHandling_1.parseValidationError)(error))), (groups) => {
            const bid = store.value.bid.current.bid;
            const x = groups
                .filter((x) => x.type === 'ParticipantUserGroup')
                .map((g) => {
                return Object.assign(Object.assign({}, g), { name: `${bid && bid.name} ${(0, translation_1.getLocalization)('bid/participant/invite/participantUserGroup')}` });
            });
            return (0, rxjs_1.of)(Actions.fetchSuccess(x));
        });
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.fetchUserGroups = fetchUserGroups;
//# sourceMappingURL=userGroups.js.map